import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-create-banner',
  templateUrl: './edit-create-banner.component.html',
  styleUrls: ['./edit-create-banner.component.scss']
})
export class EditCreateBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
